import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
import { useStripes } from '@folio/stripes/core';
var DERIVATION_RULES_PATH = '/czna-authorities/derivation-rules';
var READ_PERM = 'czna-authorities.admin.vocabulary-derivation-rules.read';
/**
 * Footer-pinned nav button for the vocabulary derivation rule administration
 * screen (CZNA-365). Mirrors `ValidationRulesNavButton`. Gated by the `read`
 * permission so only operators who can view rules see the entry (UX gate;
 * server enforces).
 */
var DerivationRulesNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var stripes = useStripes();
    var handleClick = useCallback(function () {
        if (pathname !== DERIVATION_RULES_PATH)
            history.push(DERIVATION_RULES_PATH);
    }, [history, pathname]);
    if (!stripes.hasPerm(READ_PERM))
        return null;
    var isActive = pathname === DERIVATION_RULES_PATH || pathname.startsWith("".concat(DERIVATION_RULES_PATH, "/"));
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.derivationRules' }))));
};
export default DerivationRulesNavButton;
